if (!customElements.get('heating-size-guide-us')) {
  customElements.define('heating-size-guide-us', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.unit = 'in';
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-size-unit]');
        if (button) this.setUnit(button.dataset.sizeUnit);
      });
    }

    setUnit(unit) {
      if (!['in', 'cm'].includes(unit) || unit === this.unit) return;
      this.unit = unit;
      this.querySelectorAll('[data-size-unit]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.sizeUnit === unit));
      });
      this.querySelectorAll('[data-size-heading]').forEach(heading => {
        heading.textContent = `(${unit})`;
      });
      this.querySelectorAll('[data-size-row]').forEach(row => {
        row.querySelectorAll('[data-size-cell]').forEach(cell => {
          const centimeters = Number(row.dataset[cell.dataset.sizeCell]);
          cell.textContent = unit === 'cm' ? String(centimeters) : (centimeters / 2.54).toFixed(1);
        });
      });
    }
  });
}
